import {
  NON_EXPORT_BACKUP_PRODUCT_ID,
  PRODUCT_DISPLAY_ORDER,
} from "constants/bundleAndProductIds";

const NON_EXPORT_BACKUP_FALLBACK_NAME = "Non-Export + Backup";

const GENERIC_STORAGE_BATTERY_IDS = new Set<string>(
  PRODUCT_DISPLAY_ORDER.BATTERIES.filter(
    (id) => id !== NON_EXPORT_BACKUP_PRODUCT_ID
  )
);

const isNonExportBackupProduct = (productId: string | undefined) =>
  productId === NON_EXPORT_BACKUP_PRODUCT_ID;

type BatteryLabelProduct = {
  productId?: string;
  name: string;
  count: number;
};

const getBatteryCarouselLabel = (product: BatteryLabelProduct): string => {
  if (isNonExportBackupProduct(product.productId)) {
    const name = product.name || NON_EXPORT_BACKUP_FALLBACK_NAME;
    return `${product.count} ${name}`;
  }

  if (product.productId && GENERIC_STORAGE_BATTERY_IDS.has(product.productId)) {
    return `${product.count} Storage`;
  }

  return `${product.count} ${product.name}`;
};

export {
  NON_EXPORT_BACKUP_FALLBACK_NAME,
  GENERIC_STORAGE_BATTERY_IDS,
  isNonExportBackupProduct,
  getBatteryCarouselLabel,
};
